import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyDateSelectionComponent } from '../../formly/formly-date-selection/formly-date-selection.component';
import { FormlyFileSelectionComponent } from '../../formly/formly-file-selection/formly-file-selection.component';
import { reasonForVisitSection, getRegistrationFormHeader, getPersonalInformationSection, getPassportSection, getBusinessVisaInformationSection, getCompanyInformationSection } from '../base-registration-form/form-field-config';
import { SiteService } from '../../../services/data/site.service';
import { EnumTranslationService } from '../../../services/enum-translation.service';
import { CountryService } from '../../../services/data/country.service';
import { BaseRegistrationFormComponent } from '../base-registration-form/base-registration-form.component';
import { VisitorRegistrationFormType } from '../../../models/visitor-registration-form-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-business-trip-form',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    TranslateModule,
    NgbTooltipModule,
    NgbDropdownModule, 
    ReactiveFormsModule,
    NgbDatepickerModule,
    FormlyDateSelectionComponent,
    FormlyFileSelectionComponent,
  ],
  templateUrl: './business-trip-form.component.html',
  styleUrl: './business-trip-form.component.scss'
})
export class BusinessTripFormComponent extends BaseRegistrationFormComponent implements OnInit {

  constructor(
    siteService: SiteService,
    countryService: CountryService,
    enumTranslationService: EnumTranslationService,
  ) {
    super(VisitorRegistrationFormType.BusinessTrip);

    // Intialize form fields
    this.fields = [
      ...getRegistrationFormHeader(siteService, enumTranslationService),
      ...getPersonalInformationSection(enumTranslationService),
      ...getPassportSection(countryService),
      ...getBusinessVisaInformationSection(enumTranslationService),
      ...getCompanyInformationSection(false),
      ...reasonForVisitSection,
    ];
  }

}